import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    academic_year: '',
  },
}

export const academicPeriodsUI = createSlice({
  name: 'academicPeriodsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setAcademicYear: (state, { payload }) => {
      state.tableFilters.academic_year = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const { 
  setSearch,
  setAcademicYear,
  trackActiveFilters,
  clearAllFilters,
} = academicPeriodsUI.actions

export default academicPeriodsUI.reducer
